// extracted by mini-css-extract-plugin
export default {"error-title":"styles_error-title__D0rxi","error-detail":"styles_error-detail__vlmH3","error-code":"styles_error-code__LJmNK"};